// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import CaretDown from "@guestsupply/XDL/Icons/CaretDown";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color, styledScrollbar } from "@guestsupply/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getProp from "@insite/mobius/utilities/getProp";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            list: css`
                width: 100%;
                border-radius: 0 0 4px 4px;
                /* open state */
                border: 1px solid ${color("common.ui9")};
                box-shadow: none;
                overflow-x: hidden;
                /* Styles for Safari only */
                @media not all and (min-resolution: 0.001dpcm) {
                    ${styledScrollbar(5)}
                }
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                    padding-left: 14px;
                }
                && input[aria-expanded="true"] ~ ${IconWrapper}.pre-icon {
                    transform: rotate(0);
                    padding-left: 5px;
                }
                /* open state for dropdown keep the input field as it is. */
                && input[aria-expanded="true"] {
                    border-color: ${color("secondary.main")};
                    position: relative;
                }
                && input.with-pre-icon {
                    padding: 0 30px;
                }
            `,
            formInputWrapper: css`
                ${IconWrapper}.pre-icon ~ ${TypographyStyle} {
                    padding-left: 32px;
                }
            `,
            option: css`
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0;
                line-height: 21px;
                color: ${color("text.main")};
                background: ${color("common.ui1")};
                padding: 10px;
                &:hover {
                    background: ${color("common.ui2")};
                }
            `,
            optionsGroupLabelStyle: css`
                position: sticky;
                top: 0;
                width: 100%;
                font-size: 14px;
                line-height: 21px;
                font-weight: 600;
                color: ${color("text.main")};
                background: ${color("common.ui1")};
                padding: 10px;
                margin: 0;
                border-bottom: 1px solid ${color("common.ui9")};
            `,
        },
        iconProps: {
            src: CaretDown,
            size: 13,
            color: "primary",
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 14px;
                    width: auto;
                }
                svg {
                    width: 10px;
                    height: 13px;
                }
            `,
        },
        preIconProps: {
            size: 12,
            css: css`
                display: flex;
                justify-content: flex-start;
                left: 8px;
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
